// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"da51a739f7--wrapper--NryVi","promos":"da51a739f7--promos--sKXxm","all-promos":"da51a739f7--all-promos--G2o3Q"};